import { IconProps } from "../../../types/style";

const CarTimerIcon = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;
  return (
    <div style={{ height: size + "px" }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.5 2.5V12.5C15.5 13.6 14.6 14.5 13.5 14.5H2.5V8.12C3.23 8.99 4.35003 9.53 5.59003 9.5C6.60003 9.48 7.51 9.09 8.19 8.44C8.5 8.18 8.76002 7.84999 8.96002 7.48999C9.32002 6.87999 9.52 6.15997 9.5 5.40997C9.47 4.23997 8.95001 3.21 8.14001 2.5H15.5Z"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M22.5 14.5V17.5C22.5 19.16 21.16 20.5 19.5 20.5H18.5C18.5 19.4 17.6 18.5 16.5 18.5C15.4 18.5 14.5 19.4 14.5 20.5H10.5C10.5 19.4 9.6 18.5 8.5 18.5C7.4 18.5 6.5 19.4 6.5 20.5H5.5C3.84 20.5 2.5 19.16 2.5 17.5V14.5H13.5C14.6 14.5 15.5 13.6 15.5 12.5V5.5H17.34C18.06 5.5 18.72 5.89001 19.08 6.51001L20.79 9.5H19.5C18.95 9.5 18.5 9.95 18.5 10.5V13.5C18.5 14.05 18.95 14.5 19.5 14.5H22.5Z"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.5 22.5C9.60457 22.5 10.5 21.6046 10.5 20.5C10.5 19.3954 9.60457 18.5 8.5 18.5C7.39543 18.5 6.5 19.3954 6.5 20.5C6.5 21.6046 7.39543 22.5 8.5 22.5Z"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16.5 22.5C17.6046 22.5 18.5 21.6046 18.5 20.5C18.5 19.3954 17.6046 18.5 16.5 18.5C15.3954 18.5 14.5 19.3954 14.5 20.5C14.5 21.6046 15.3954 22.5 16.5 22.5Z"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M22.5 12.5V14.5H19.5C18.95 14.5 18.5 14.05 18.5 13.5V10.5C18.5 9.95 18.95 9.5 19.5 9.5H20.79L22.5 12.5Z"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.5 5.5C9.5 6.7 8.97001 7.77 8.14001 8.5C7.43001 9.12 6.51 9.5 5.5 9.5C3.29 9.5 1.5 7.71 1.5 5.5C1.5 4.24 2.08 3.11 3 2.38C3.69 1.83 4.56 1.5 5.5 1.5C7.71 1.5 9.5 3.29 9.5 5.5Z"
          stroke={color}
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.75 4.25V5.75L4.5 6.5"
          stroke={color}
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
};

export default CarTimerIcon;
